export default function App() {
  return <div>Admin Portal Submodule</div>;
}
